import { MetadataElementProps, MetadataItem } from './types';
import { isMetadataWithProperty, isMetadataWithName, makeMetadataKey } from './utils';

type MappedMetadataElementsProps = React.JSX.IntrinsicAttributes & {
  items?: MetadataItem[];
};

export const MetadataElement = ({ meta, key }: MetadataElementProps & { key?: string }) => {
  if (isMetadataWithName(meta)) {
    return <meta name={meta.name} content={meta.content} key={key} />;
  }
  if (isMetadataWithProperty(meta)) {
    return <meta property={meta.property} content={meta.content} key={key} />;
  }
  return <></>;
};

export const mapMetadataElements = ({ items }: MappedMetadataElementsProps): React.JSX.Element[] =>
  (items ?? [])
    .filter((i) => !!i)
    .map((meta) => MetadataElement({ meta, key: makeMetadataKey(meta) }));

export default MetadataElement;
